<div *ngIf="!listDisplay">
  <div *ngIf="!display">
    <div class="content-wrapper">
      <div>
        <div>
          <div>
            <div class="btn-wrapper">
              <button mat-flat-button class="btn-back btn-warn" color="" aria-label="Back" (click)='back()'>
                <span>{{'questions.typeOfQuestions.surveyNumberRating.btnBack' | translate}}</span>
              </button>
              <span class="spacer"></span>
              <!-- <button mat-flat-button color="" class="btn-warn" aria-label="Preview" disabled="disabled">
                <span>Preview</span>
              </button> -->
              <button [disabled]="!this.addQuestionForm.valid" mat-flat-button color="" class="btn-primary" aria-label="Save"
                (click)='saveNumberRatingQuestion()'>
                <span>{{'questions.typeOfQuestions.surveyNumberRating.btnSave' | translate}}</span>
              </button>
            </div>
          </div>
        </div>
        <div class="text-msg" *ngIf="saveDataValidation==true">
          <span>Please Fill the Form</span>
        </div>
      </div>
      <div>
        <div>
          <div>
            <div class="filter-section">
              <div class="body-section title">
                <mat-icon>library_add</mat-icon> &nbsp;
                <span>{{'questions.typeOfQuestions.surveyNumberRating.title' | translate}}</span>
              </div>
            </div>
            <form [formGroup]="addQuestionForm">
              <div class="editor1" formGroupName="questiondescription">
                <label class="que-label">{{'questions.typeOfQuestions.surveyNumberRating.labelQuest' | translate}}</label>
                <ckeditor #myEditor formControlName="description" [editor]="Editor" (ready)="onReady($event)" (click)="onClick(true)"></ckeditor>
                <div *ngIf="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
                <!-- <ckeditor formControlName="description" data="Enter here..." [config]="ckeditorConfig" [ngClass]="{'ckeditor-loading': isCkeditorLoading}" (ready)="onCkeditorReady()"></ckeditor> -->

              </div>
              <div class="btn-container">
                <button mat-flat-button color="warn" class="btn-warn" (click)='openOptionDiv()'>{{'questions.typeOfQuestions.surveyNumberRating.btnAddNum' | translate}}</button>
              </div>
              <div class="form-seq" formArrayName="options">
                <div class="input-holder" *ngFor="let item of this.optionArray.controls; let i = index" [formGroupName]="i">
                  <span>
                    <span class="lebalText">
                      {{'questions.typeOfQuestions.surveyNumberRating.labelValue' | translate}} {{i+1}}<span class="error" *ngIf="i < 3">*</span></span> <input min="0" class="input-h"
                      type="number" name="" formControlName="optionId" required>
                    <button mat-icon-button  [class.disabled]="roleSer.accessData? !roleSer.accessData.deleteAllowed:true" class="delete-icon" *ngIf="i >= 3" (click)="deleteOptionDiv(i)" ><i-feather name="trash-2"></i-feather></button>
                  </span>

                </div>
              </div>
              <div class="form-seq">
                <div class="input-holder">
                  <span>
                    <span class="lebalText">
                      {{'questions.typeOfQuestions.surveyNumberRating.labelValOpen' | translate}}
                    </span> <input class="input-h" type="text" name="" formControlName="Ratinglow">
                  </span>
                  <span>
                    <span class="lebalText">
                      {{'questions.typeOfQuestions.surveyNumberRating.labelValClose' | translate}}
                    </span> <input class="input-h" type="text" name="" formControlName="Ratinghigh">
                  </span>
                </div>
              </div>
              <div class="exp-panel">
                <mat-accordion>
                  <mat-expansion-panel>
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        {{'questions.typeOfQuestions.surveyNumberRating.accordian.title' | translate}}
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="container-fluid">
                      <div class="row">
                        <div class="col-md-2 answers-label">
                          <div class="form-label">
                            <label>{{'questions.typeOfQuestions.surveyNumberRating.accordian.selectOptions.option1.label' | translate}}</label>
                          </div>
                        </div>
                        <div class="col-md-3">
                          <mat-form-field class="scoring-type" appearance="fill">
                            <mat-select formControlName="questiondisplayoptions">
                              <mat-option [value]="option.title" *ngFor="let option of QuestionOrientation">{{option.title}}</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </mat-expansion-panel>
                </mat-accordion>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="display">
    <app-choose-question-type></app-choose-question-type>
  </div>
</div>


<div *ngIf="listDisplay">
  <app-question-list></app-question-list>
</div>
